import { ticketClient } from "@/api/index";
import { GetRolePerformanceReq } from "@/pbjs/xcommon/ticket_pb";
import { setCommon, handleResponse, errorMsg, setPage } from "@/utils/request";
import { setMetaData } from "@/utils";
// lee 绩效接口参数
interface Options {
  UserName?: string;
  ItemId: number; // 工单分类
  Userid: number; // 用户id
  UserGroupId?: string; // 角色
  Timerange: string;
  CompareType: number;
  pageIndex: number;
  pageSize: number;
  Statstype: number;
}
export function getRolePerformanceExcel(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new GetRolePerformanceReq();
      request.setCommonin(setCommon());
      request.setItemid(arg.ItemId); // 工单分类
      request.setUserid(arg.Userid); // 用户id
      if (arg.UserGroupId) {
        request.setUsergroupid(Number(arg.UserGroupId)); // 角色
      }
      if (arg.UserName) {
        request.setUsername("" + arg.UserName); // 角色
      }
      request.setTimerange(arg.Timerange);
      request.setComparetype(arg.CompareType);
      request.setPagein(setPage(arg.pageIndex, arg.pageSize));
      request.setStatstype(arg.Statstype);
      // setRank
      let _res = await ticketClient.getRolePerformanceExcel(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            resolve(response);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
// function getWorkerPerformance(arg: Options) {
//     let _res = getWorkerPerformanceApi(arg);
//     return _res;
// }
